import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, filter, map, switchMap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

import * as ContentActions from './content.actions';
import { ContentV11Service } from '@api/rest';

@Injectable()
export class ContentEffects {
  private actions$ = inject(Actions);
  private contentHttp = inject(ContentV11Service);


  loadContents$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ContentActions.loadContents),
      switchMap(() => this.contentHttp.restV11ContentGet(true, true)
        .pipe(
          map(contents => ContentActions.loadContentsSuccess({ contents })),
          catchError(error => of(ContentActions.loadContentsFailure({ error })))
        )
      )
    );
  });

  setSelected: Observable<any> = createEffect(() =>
    this.actions$.pipe(
      ofType('@ngrx/router-store/navigated'),
      map((action: any) => action.payload.event.url.split('/')),
      filter(routes => routes.includes('content')),
      map(routes => routes[ routes.findIndex(route => route === 'content') + 1 ]),
      map(id => ContentActions.setSelectedContent({ id }))
    )
  );

  getContent$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ContentActions.getContent),
      switchMap(payload => this.contentHttp.restV11ContentIdGet(payload.id)
        .pipe(
          map(content => ContentActions.getContentSuccess({ content })),
          catchError(error => of(ContentActions.getContentFailure({ error })))
        )
      )
    );
  });

}
